import { render } from "./BlogZircVenColor.vue?vue&type=template&id=b119ec26"
import script from "./BlogZircVenColor.vue?vue&type=script&lang=js"
export * from "./BlogZircVenColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__